import React from 'react';
import './types.css'
import ResultText from '../Result/ResultText'

export default function Login({ history }) {

    const goToProfileType = (event) => {
        event.preventDefault();
        history.push(
            {
                pathname: '/details',
                search: `?type=${event.target.value}`
            })
    }

    function goToHome(){
        history.push('/home')
    }

    return (
        <div>
            <div onClick={goToHome} className='container-arrow'>
                <i className="left"></i>
                <p className='text-back'>Voltar</p>
            </div>
            <button type="submit" className="btn" onClick={goToProfileType} value={1}>{ResultText.type_and_name[0]}</button>
            <button type="submit" className="btn" onClick={goToProfileType} value={2}>{ResultText.type_and_name[1]}</button>
            <button type="submit" className="btn" onClick={goToProfileType} value={3}>{ResultText.type_and_name[2]}</button>
            <button type="submit" className="btn" onClick={goToProfileType} value={4}>{ResultText.type_and_name[3]}</button>
            <button type="submit" className="btn" onClick={goToProfileType} value={5}>{ResultText.type_and_name[4]}</button>
            <button type="submit" className="btn" onClick={goToProfileType} value={6}>{ResultText.type_and_name[5]}</button>
            <button type="submit" className="btn" onClick={goToProfileType} value={7}>{ResultText.type_and_name[6]}</button>
            <button type="submit" className="btn" onClick={goToProfileType} value={8}>{ResultText.type_and_name[7]}</button>
            <button type="submit" className="btn" onClick={goToProfileType} value={9}>{ResultText.type_and_name[8]}</button>
        </div>
    );
}